import { useNavigate } from 'react-router-dom'

import { Button, Card } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import type PayrollPolicy from 'modules/payroll_bundle/store/models/Policy'

interface Props {
  payrollPolicy: PayrollPolicy
  employeeCount: number
}

const PayrollPolicyItem = ({ payrollPolicy, employeeCount }: Props) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const policyId = payrollPolicy.attributes.id

  const handleItemClick = () => {
    navigate(
      navigation.settings.payroll_bundle.policies.fullPath({
        policyId: Number(payrollPolicy.attributes.id),
      })
    )
  }

  return (
    <Card key={policyId}>
      <Card.Title
        action={<Button onClick={handleItemClick} type="secondary" iconName="arrow-right" />}
        size="small"
      >
        {payrollPolicy.attributes.name}
      </Card.Title>
      <Card.Description>
        {i18n.t('payroll_bundle.policy_period.settings.new_employee_count', {
          count: employeeCount,
        })}
      </Card.Description>
    </Card>
  )
}

export default observer(PayrollPolicyItem)
